import {setShowNoFirsModal} from '../../common';

export interface ExtendedError extends Error {
    fullErrorsList?: {code: string; message: string}[];
}

export function errorHandlerNoFirs(getError: ExtendedError) {
    const NO_FIRS_CREDS = 'No FIRS credentials found';
    const hasNoFirsError = getError.fullErrorsList?.find((i) => i.code === '404');

    if (hasNoFirsError && hasNoFirsError.message === NO_FIRS_CREDS) {
        setShowNoFirsModal(true);
    }
}
